// hooks/useCanvasHandler.js
// import { useState } from "react";
import Swal from "sweetalert2";

// Importing Contexts
import { useCanvas } from "contexts/canvas-context";
// import { useReload } from "contexts/ReloadContext";
// import { Toast } from "react-bootstrap";

export const useCanvasHandler = () => {
  // Contexts
  const { showCanvas, hideCanvas } = useCanvas();

  const handleSuccess = (
    withAlert = true,
    customMessage = "Data has been successfully saved"
  ) => {
    hideCanvas();
    if (withAlert) {
      Swal.fire({
        icon: "success",
        title: "Success!!!",
        text: customMessage,
        timer: 1000, // Waktu dalam milidetik
      });
      //   Toast.fire({
      //     icon: "success",
      //     title: "Data has been successfully saved",
      //   });
    }
  };

  const handleSuccessToast = (
    withAlert = true,
    customMessage = "Data has been successfully saved"
  ) => {
    hideCanvas();
    if (withAlert) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: customMessage,
        // title: "Processing...",
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading(); // Menampilkan spinner loading
        },
      });

      // Simulasikan proses async, kemudian tampilkan toast sukses
      setTimeout(() => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Data successfully saved!",
          showConfirmButton: false,
          timer: 1000,
        });
      }, 1000); // Delay 2 detik untuk loading
    }
  };

  const handleLoadingThenSuccessToast = async () => {
    // Tampilkan loading toast
    // const loadingToast = Swal.fire({
    //   toast: true,
    //   position: "top-end",
    //   title: "Loading...",
    //   showConfirmButton: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   },
    // });

    // Simulasi proses async (misalnya, API call)
    await new Promise((resolve) => setTimeout(resolve, 2000));

    // Tutup loading toast dan tampilkan toast sukses
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Data successfully saved!",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  };

  const handleError = (arg1 = true, arg2 = "An error occurred!") => {
    hideCanvas();

    let message = arg2;
    let shouldAlert = true;

    if (typeof arg1 === "boolean") {
      shouldAlert = arg1;
      message = arg2;
    } else if (typeof arg1 === "string") {
      shouldAlert = true;
      message = arg1;
    } else if (typeof arg1 === "object" && arg1 !== null) {
      shouldAlert = true;
      message = arg1.message || arg1.error || arg2;

      // Handle validation errors (422)
      if (arg1.errors) {
        const validationMessages = Object.values(arg1.errors)
          .flat()
          .join("\n");
        message = `${message}\n\n${validationMessages}`;
      }
    }

    if (shouldAlert) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: message,
      });
    }
  };

  const showCanvasHandler = (title, bodyComponent, className) => {
    showCanvas({
      title: title,
      body: bodyComponent,
      className: className,
    });
  };

  return {
    handleSuccess,
    handleError,
    showCanvasHandler,
    handleSuccessToast,
    handleLoadingThenSuccessToast,
  };
};
